import { createContext } from 'react';

export type ThemeVariant = 'light' | 'dark';

export type ThemeContextState = {
  themeVariant: ThemeVariant;
  toggleThemeVariant: () => void;
};

export const ThemeContext = createContext<ThemeContextState | undefined>(undefined);
